import apiClient from './api';

class PackageService {
  constructor() {
    this.api = apiClient;
  }

  // Package CRUD operations
  async getAllPackages() {
    const response = await this.api.get('/package');
    return response.data;
  }

  async getPackageById(id) {
    const response = await this.api.get(`/package/${id}`);
    return response.data;
  }

  async createPackage(packageData) {
    const response = await this.api.post('/package', packageData);
    return response.data;
  }

  async updatePackage(id, packageData) {
    const response = await this.api.put(`/package/${id}`, packageData);
    return response.data;
  }

  async deletePackage(id) {
    const response = await this.api.delete(`/package/${id}`);
    return response.data;
  }

  // Patient package operations
  async getPatientPackages(patientId) {
    const response = await this.api.get(`/package/patient/${patientId}`);
    return response.data;
  }

  async purchasePackage(purchaseData) {
    const response = await this.api.post('/package/purchase', purchaseData);
    return response.data;
  }

  async consumePackageSession(sessionData) {
    const response = await this.api.post('/package/use-session', sessionData);
    return response.data;
  }

  async getSessionUsageHistory(patientPackageId) {
    const response = await this.api.get(`/package/usage-history/${patientPackageId}`);
    return response.data;
  }
}

const packageService = new PackageService();
export default packageService;